import { z } from 'zod/v4';

/** The document ids to archive for the caller's company — a bare array, as legacy took it. */
export const BulkArchiveCompanyDocumentsBodySchema = z
  .array(z.string().min(1))
  .min(1);

/**
 * The ids this call newly archived. Ids the caller cannot see, and ids it had
 * already archived, are skipped rather than failing the batch, so this can be
 * shorter than the request.
 */
export const BulkArchiveCompanyDocumentsResponseSchema = z.object({
  archivedDocumentIds: z.array(z.string()),
});

export type BulkArchiveCompanyDocumentsBody = z.infer<
  typeof BulkArchiveCompanyDocumentsBodySchema
>;
export type BulkArchiveCompanyDocumentsResponse = z.infer<
  typeof BulkArchiveCompanyDocumentsResponseSchema
>;
